import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';

import fetcher from 'utils/fetcher';
import TRENDING_FEED_QUERY from 'endpoints/Home/trendingFeed.gql';

export interface TrendingLink {
  title: string;
  url: string;
  order: number;
}

export interface TrendingFeedData {
  sectionTitle: string;
  visible: boolean;
  links: TrendingLink[];
}

interface TrendingFeedProviderProps {
  children: ReactNode;
}

const TrendingFeedContext = createContext<TrendingFeedData | null>(null);

export const TrendingFeedProvider = ({
  children,
}: TrendingFeedProviderProps) => {
  const [data, setData] = useState<TrendingFeedData | null>(null);

  useEffect(() => {
    async function getData() {
      try {
        const response = await fetcher(TRENDING_FEED_QUERY);
        if (response?.trendingFeed?.json) {
          const parsed = JSON.parse(response.trendingFeed.json);
          setData(parsed);
        }
      } catch (err) {
        console.error('Error fetching trending feed:', err);
      }
    }
    getData();
  }, []);

  return (
    <TrendingFeedContext.Provider value={data}>
      {children}
    </TrendingFeedContext.Provider>
  );
};

export const useTrendingFeed = () => {
  return useContext(TrendingFeedContext);
};

export default TrendingFeedContext;
